import { CheckIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import type { RootState } from '../../../store/store';
import classNames from '../../../utils/classNames';
import { ROUTES } from '../../../utils/routes';

const NEWSLETTER_OBJECTIVES = [
  'Présenter le référent mutation location aux copropriétaires',
  "Expliquer le traitement réalisé par le cabinet sur les DPE : l'explication de ce traitement permet ensuite la justification du traitement des DPE à la semaine",
];

function NewsletterSection() {
  const company = useSelector((state: RootState) => state.auth.company);
  const hasSentNewsletter = Boolean(company?.mandatoryNewsletterSentAt);

  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-md">
      {/* Header */}
      <div className="flex items-center justify-between gap-4 bg-gradient-to-r from-blue-900 to-rgpd-blue px-7 py-4">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/[.18] text-[17px]">
            <span role="img" aria-label="mail">&#x1F4E8;</span>
          </div>
          <div>
            <div className="text-[15px] font-bold text-white">
              Envoi de la première newsletter aux copropriétaires
            </div>
            <div className="mt-0.5 text-[11px] text-white/65">
              {hasSentNewsletter ? 'Première newsletter envoyée' : 'Étape en cours'}
            </div>
          </div>
        </div>
        <span
          className={classNames(
            'rounded-full px-3.5 py-1 text-[11px] font-bold tracking-wide whitespace-nowrap',
            hasSentNewsletter
              ? 'bg-green-100 text-green-800'
              : 'bg-amber-50 text-amber-700 border border-amber-200',
          )}
        >
          {hasSentNewsletter ? <><span role="img" aria-label="check mark">&#x2713;</span> ENVOY&Eacute;E</> : 'EN COURS'}
        </span>
      </div>

      {/* Body */}
      <div className="px-7 py-5">
        <p className="mb-5 text-[13px] leading-relaxed text-gray-700">
          Cette newsletter a <strong className="text-blue-900">2 objectifs</strong> : présenter le
          référent mutation location et expliquer le traitement réalisé par le cabinet sur les DPE.
        </p>

        <div className="mb-6 flex flex-col gap-2.5">
          {NEWSLETTER_OBJECTIVES.map((objective) => (
            <div key={objective} className="flex items-start gap-2.5 text-[13px] leading-snug text-slate-700">
              <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100">
                <CheckIcon className="h-2.5 w-2.5 text-green-800" />
              </div>
              <span>{objective}</span>
            </div>
          ))}
        </div>

        <Link
          to={ROUTES.COMMUNICATION_NEWSLETTER_LIST}
          className="inline-flex items-center gap-2.5 rounded-xl bg-rgpd-blue px-5 py-3.5 text-[13px] font-bold text-white transition-colors hover:bg-rgpd-blue-dark"
        >
          <span>&rarr;</span>
          Accéder à la newsletter
        </Link>
      </div>
    </div>
  );
}

function ParametrageLancementTab() {
  return (
    <div className="flex flex-col gap-8">
      <div>
        <h2 className="mb-5 text-xl font-bold text-slate-800">
          Envoyez la première Newsletter à tous les copropriétaires
        </h2>
        <NewsletterSection />
      </div>
    </div>
  );
}

export default ParametrageLancementTab;
